import * as React from "react";
import { useState } from "react";
import { connect } from "react-redux";
import { Field, getFormValues, InjectedFormProps, reduxForm } from "redux-form";
import { SelectField, TextField } from "common-fields";
import { Button } from "reactstrap";
import { AxiosError, AxiosResponse } from "axios";
import FinSpinner from "../../commonfields/FinSpinner";
import Service from "../../services";
import { catchError } from "../../utils/Utils";
import { BankUserContext } from "../../bankUserContext";
import NormalizeSpace from "../../utils/NormalizeSpace";
import { toast } from "react-toastify";

interface archiveFormProps {
  confirmCloseHandle: (closeTag: boolean) => void;
  selectedClient?: any;
}

const validate = (values: any) => {
  const errors: any = {};
  if (!values.ArchiveReasonDropdown) {
    errors.ArchiveReasonDropdown = "Required";
  }
  if (!values.ArchiveReason) {
    errors.ArchiveReason = "Required";
  } else if (values.ArchiveReason.length < 5) {
    errors.ArchiveReason = "Must be at least 5 characters";
  } else if (values.ArchiveReason.length > 60) {
    errors.ArchiveReason = "Must be 60 characters or less";
  }

  return errors;
};

const ArchiveForm: React.FC<archiveFormProps & InjectedFormProps<any, any>> = (
  props: any
) => {
  const [users, setUsers] = useState<any>([]);
  const [loader, setLoader] = useState(false);
  const context = React.useContext(BankUserContext);
  const service = new Service();

  React.useEffect(() => {
    const data = {
      screen: "ProspectDetails",
      sections: "getArchiveOptions",
      orgId: context.bankuserDetails?.organization.orgId,
      isJsonReturnObject: false,
    };
    service
      .getArchiveOptions(data)
      .then((response: AxiosResponse) => {
        const optionsData = response.data.map((each: any) => ({
          value: each.optionText,
          text: each.optionText,
        }));
        setUsers(optionsData);
      })
      .catch((error: AxiosError) => {
        catchError(error, true);
      });
  }, []);

  const archiveClient = () => {
    const data = {
      orgId: context.bankuserDetails?.organization.orgId,
      archiveType: props?.formValues?.ArchiveReasonDropdown,
      isArchive: true,
      clientProductsId: props?.selectedClient?.clientProductsId,
      archiveReason: props?.formValues?.ArchiveReason,
      status: props?.selectedClient?.status,
      clientId: props?.selectedClient?.clientId,
      productId: props?.selectedClient?.productId,
      productCode: props?.selectedClient?.productCode,
    };
    service
      .updateArchiveStatus(data)
      .then(() => {
        props.confirmCloseHandle(true);
      })
      .catch((error: any) => {
        const status = error.response ? error.response.status : null;
        if (status === 500) {
          toast.error((error?.response?.data?.errorMessage))
          props.confirmCloseHandle(true);
        }
      });
  };

  return (
    <div className="archiveTodoForm">
      {loader ? <FinSpinner /> : null}
      <form className="form-group">
        <div className="archive mb-3">
          <Field
            component={SelectField}
            name={"ArchiveReasonDropdown"}
            label={"Category"}
            values={users}
            isRequired={true}
          />
        </div>
        <Field
          component={TextField}
          type="text"
          name={"ArchiveReason"}
          label={"Reason"}
          isRequired={true}
          normalize={NormalizeSpace}
        />

        <Button
          className="yes"
          disabled={props?.pristine || props?.submitting || props?.invalid}
          onClick={() => archiveClient()}
        >
          Archive
        </Button>
        <Button className="no" onClick={() => props.confirmCloseHandle(false)}>
          Cancel
        </Button>
      </form>
    </div>
  );
};

export default connect((state: any, props: any) => {
  return {
    initialValues: {
      todoDescription: props?.todo?.todoDescription,
    },
    formValues: getFormValues("ArchiveForm")(state),
  };
})(
  reduxForm<any, any>({
    form: "ArchiveForm",
    enableReinitialize: true,
    validate,
  })(ArchiveForm)
);
